import type { TranslationsByLanguage } from '@susu/i18n'
import de from './de.json'
import en from './en.json'
import es from './es.json'
import fr from './fr.json'
import it from './it.json'
import ko from './ko.json'
import nl from './nl.json'
import pl from './pl.json'
import sv from './sv.json'
import zh from './zh.json'

export const translations: TranslationsByLanguage = {
  de,
  en,
  es,
  fr,
  it,
  ko,
  nl,
  pl,
  sv,
  zh,
}

export const supportedLanguages = Object.keys(translations)

export const getTranslations = (language: string) => {
  return translations[language] || translations.en
}
